<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { ListSelectionDialogViewModel } from '@common/Components/ListSelectionDialog'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: ListSelectionDialogViewModel
    }>()

    const emit = defineEmits<{
        (e: 'update-value', value: string | null, id: number | string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.isOpened === true)
    const title = computed(() => vm.value?.title)

    // ---------------- methods ----------------

    function updateValue(val: string)
    {
        vm.value.selectedValue =
            vm.value.selectedValue === val
                ? null
                : val
    }

    function confirm()
    {
        emit('update-value', vm.value.selectedValue, vm.value.id)
    }

    function close()
    {
        vm.value.isOpened = false
    }
</script>


<template>
    <div class="modal-mask" v-if="opened === true">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div v-if="vm.description" class="alert alert-warning" role="alert">
                            {{vm.description}}
                        </div>

                        <div class="list-group">
                            <button v-for="item in vm.items" :key="item.key"
                                    :class="['list-group-item', 'list-group-item-action', { 'active': item.value == vm.selectedValue }]"
                                    @click="updateValue(item.value)">
                                {{ item.label }}
                                <small v-if="item.description != null"><br />{{item.description}}</small>
                            </button>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="confirm" type="button" class="btn btn-primary" :disabled="vm.valueRequired && vm.selectedValue == null">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>

    .list-group-item {
        border-top-width: 1px !important;
    }
</style>